/**
 * @date 03/14/2017
 * @copyright 2016 Empower Retirement
 * @description
 *
 * Used as the view model or mediator for the corresponding view. All data, state, business logic, and API
 * communication exist in the service layer.
 *
 */
import ExternalLogger from "../../logger/ExternalLogger";

const TransactionMessagesController = function (
    $scope,
    $q,
    $state,
    $rootScope,
    $translate,
    eventBus,
    accountService,
    transactionMessagesService,
    $interval
) {
    const logger = ExternalLogger.getInstance("TransactionMessagesController");
    const vm = this;
    vm.activeGroupAccount = accountService.getActiveGroupAccount();
    vm.indId = vm.activeGroupAccount.individualId;
    vm.groupId = vm.activeGroupAccount.groupId;
    vm.showWithdrawalLink = null;

    vm.hasContent = false;

    /**
     * Resets the transactionMessages variable on the service.
     * This will make sure we dont flash the template in the UI
     * when moving between states in the same view
     */
    transactionMessagesService.resetMessage();

    /**
     * Determines if the transactional messages column should show.
     * @return {Boolean}
     */
    vm.showMessagesColumn = function () {
        const showMessage = vm.hasContent && transactionMessagesService.showMessagesColumn();
        const e = $scope.$emit("showMessage", showMessage);
        return showMessage;
    };

    vm.disableScroll = $scope.disableScroll;

    vm.layoutPosition = $scope.layoutPosition;

    if ($scope.useAccountDetailsLayout) {
        vm.useAccountDetailsLayout = $scope.useAccountDetailsLayout == "true";
    } else {
        vm.useAccountDetailsLayout = false;
    }

    /**
     * Performs the API call to get the list of transaction messages and then applies them to the screen.
     * @return {Promise}
     */
    vm.getTransactionMessages = function () {
        const getTransactionMessagesSuccess = function (data) {
            logger.debug("getTransactionMessagesSuccess()");

            if (Array.isArray(data)) {
                data.forEach(function (msg, index) {
                    if (msg.information) {
                        const isLast = index === data.length - 1;
                        const suffix = isLast ? "" : "<br /><br />";
                        vm.transactionMessages += msg.information + suffix;
                    }
                });
                vm.hasContent = true;
            }

            return data;
        };

        const getTransactionMessagesFault = function (fault) {
            logger.warn("getTransactionMessagesFault( {0} )", [fault]);
            return $q.reject(fault);
        };

        if ($scope.activeGroupId) {
            var groupId = $scope.activeGroupId;
        } else {
            var groupId = vm.groupId;
        }

        const functionCode = transactionMessagesService.getTransactionMessageFunctionCode();
        const functionCodeLayoutPosition =
            transactionMessagesService.getTransactionMessageLayoutPosition();

        if (
            functionCode ==
                transactionMessagesService.VIEWS.DISTRIBUTION_AMOUNT_PAGE.FUNCTION_CODE ||
            functionCode ==
                transactionMessagesService.VIEWS.DISTRIBUTION_LANDING_PAGE.FUNCTION_CODE ||
            functionCode == transactionMessagesService.VIEWS.DISTRIBUTION_REASONS_PAGE.FUNCTION_CODE
        ) {
            var afFlagCheckInterval = $interval(function () {
                if (angular.isDefined($rootScope.afProvCompFlag)) {
                    vm.showWithdrawalLink = $rootScope.afProvCompFlag;
                    $interval.cancel(afFlagCheckInterval);
                    afFlagCheckInterval = 0;
                }
            }, 1000);
        } else {
            vm.showWithdrawalLink = false;
        }

        logger.debug("getTransactionMessages( groupId = {0}, functionCode = {1} )", [
            groupId,
            functionCode
        ]);

        // Reset the list of transaction messages so we're not adding incorrect or old messages to
        // an existing list.
        vm.transactionMessages = "";

        if (vm.useAccountDetailsLayout) {
            if (
                functionCode &&
                functionCode != "" &&
                functionCodeLayoutPosition == vm.layoutPosition
            ) {
                return transactionMessagesService
                    .getTransactionMessages(groupId, functionCode)
                    .then(getTransactionMessagesSuccess, getTransactionMessagesFault);
            } else {
                vm.hasContent = false;
            }
        } else {
            // nonqual using this scenario. It doesn't use AccountDetails layout
            if (functionCode && functionCode != "") {
                return transactionMessagesService
                    .getTransactionMessages(groupId, functionCode)
                    .then(getTransactionMessagesSuccess, getTransactionMessagesFault);
            } else {
                vm.hasContent = false;
            }
        }
    };

    /**
     * In order to make sure we're grabbing the appropriate transaction messages for each UI view we'll need
     * to request the messages from the API on each UI state change.
     */
    const onStateChangeSuccess = function () {
        vm.getTransactionMessages();
    };

    //-----------------------------------------------------------------------
    // EVENT HANDLERS
    //-----------------------------------------------------------------------

    // We need to listen to state changes in order to show the transaction messages per view.
    $rootScope.$on("$stateChangeSuccess", onStateChangeSuccess);

    // Initialization
    vm.getTransactionMessages();

    vm.openPopUpForAmFunds = function () {
        $rootScope.$emit("openModalPopUpForTTK", vm.transactionMessages);
    };
};

TransactionMessagesController.$inject = [
    "$scope",
    "$q",
    "$state",
    "$rootScope",
    "$translate",
    "eventBus",
    "accountService",
    "transactionMessagesService",
    "$interval"
];
export default TransactionMessagesController;
